import Vue from "vue";
import VueRouter from "vue-router";
import smartquotes from "smartquotes";
import store from "./store";

const Home = () => import(/* webpackChunkName: "home" */ "../views/Home.vue");
const About = () =>
  import(/* webpackChunkName: "about" */ "../views/About.vue");
const Contact = () =>
  import(/* webpackChunkName: "contact" */ "../views/Contact.vue");
const Gallery = () =>
  import(/* webpackChunkName: "static" */ "../views/Gallery.vue");
const Class = () =>
  import(/* webpackChunkName: "static" */ "../views/Class.vue");
const Terms = () =>
  import(/* webpackChunkName: "termsPrivacy" */ "../views/Terms.vue");
const Privacy = () =>
  import(/* webpackChunkName: "termsPrivacy" */ "../views/Privacy.vue");
const Login = () =>
  import(/* webpackChunkName: "static" */ "../views/Login.vue");
const Dashboard = () =>
  import(/* webpackChunkName: "static" */ "../views/Dashboard.vue");
const Video = () =>
  import(/* webpackChunkName: "static" */ "../views/Video.vue");
const dashUser = () =>
  import(/* webpackChunkName: "static" */ "../views/DashUser.vue");
const Error404 = () =>
  import(/* webpackChunkName: "404" */ "../views/Error404.vue");

const routes = [
  {
    path: "/",
    component: Home,
    meta: {
      title: "DrillMaps"
      // layout: "website"
    }
  },
  {
    path: "/home/:device_type?",
    component: Home,
    meta: {
      title: "DrillMaps"
      // layout: "website"
    }
  },
  {
    path: "/about",
    component: About,
    meta: {
      title: "About"
    }
  },
  {
    path: "/login",
    component: Login,
    meta: {
      title: "DrillMaps",
      layout: "website"
    }
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: {
      title: "DrillMaps",
      layout: "website"
    }
  },
  {
    path: "/dashUser",
    component: dashUser,
    meta: {
      title: "DrillMaps",
      layout: "website"
    }
  },
  {
    path: "/gallery",
    component: Gallery,
    meta: {
      title: "Investors"
    }
  },

  {
    path: "/terms/:device_type?",
    component: Terms,
    meta: {
      title: "Terms of Service"
    }
  },
  {
    path: "/privacy/:device_type?",
    component: Privacy,
    meta: {
      title: "Privacy Policy"
    }
  },
  {
    path: "/contact/:device_type?",
    component: Contact,
    meta: {
      title: "Contact us"
    }
  },
  {
    path: "/class",
    component: Class,
    meta: {
      title: "Aura"
    }
  },
  {
    path: "/video/:sessionId/:token",
    component: Video,
    meta: {
      title: "Aura",
      layout: "website"
    }
  },
  {
    path: "/logout",
    component: Class,
    meta: {
      title: "Aura"
    }
  },
  {
    path: "*",
    component: Error404,
    meta: {
      title: "404 Error"
    }
  }
];

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    const position = savedPosition || {
      x: 0,
      y: 0
    };
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(position);
      }, 200);
    });
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.auth) {
    setTimeout(() => {
      if (!store.state.user) {
        localStorage.setItem("goBackTo", to.path);
        router.push("/login/goBackTo");
        return;
      }
    }, 1);
  }
  if (to.meta && to.meta.userallow) {
    setTimeout(() => {
      // console.log(store.state.user.emailVerified);
      if (store.state.user != null) {
        if (!store.state.user.emailVerified) {
          localStorage.setItem("goBackTo", to.path);
          router.push("/settings/general");
          return;
        }
      }
    }, 1);
  }
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle)
    document.title =
      nearestWithTitle.meta.title +
      ((nearestWithTitle.meta.title.indexOf("DrillMaps") === -1 &&
        " · DrillMaps") ||
        "");
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  Array.from(document.querySelectorAll("[data-routerMetas]")).map(el =>
    el.parentNode.removeChild(el)
  );
  if (!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });
      tag.setAttribute("data-routerMetas", "");
      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));
  next();
});

router.afterEach(() => {
  setTimeout(() => {
    smartquotes();
  }, 301);
});

export default router;
